<pcs-label-item
  *ngFor="let userLabel of data; trackBy: trackByIndex;"
  [name]="getName(userLabel)"
  [color]="getColor(userLabel)"
  class="mb-1 me-1">
</pcs-label-item>
